export enum PublishModeTab {
  Endpoint = 'introspection',
  SchemaFile = 'localSchemaFile',
  SchemaReporting = 'schemaReporting',
  Federation = 'federation',
  CI = 'continuousIntegration',
}
